import { motion } from "framer-motion";
import { Zap } from "lucide-react";
import { MARQUEE_ITEMS } from "../data/site";
import { useRatingFigures } from "./LiveRatingProvider";

export const TrustStrip = () => {
  const { rating, count } = useRatingFigures();
  const METRICS = [
    { value: rating, label: "Google star rating", tid: "trust-strip-rating" },
    { value: String(count), label: "Google reviews", tid: "trust-strip-reviews" },
    { value: "8 yrs", label: "On the Sunshine Coast", tid: "trust-strip-years" },
    { value: "100%", label: "Mobile — we come to you", tid: "trust-strip-mobile" },
  ];

  return (
  <section data-testid="trust-strip" className="border-y border-line bg-surface/40">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 grid grid-cols-2 lg:grid-cols-4">
      {METRICS.map((m, i) => (
        <motion.div
          key={m.tid}
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.5, delay: i * 0.08 }}
          data-testid={m.tid}
          className="py-8 lg:py-10 px-4 sm:px-6 border-line border-b-2 lg:border-b-0 lg:border-r-2 last:border-r-0 even:border-r-0 lg:even:border-r-2"
        >
          <p className="font-display font-bold text-4xl sm:text-5xl text-slate-50 leading-none">
            {m.value}
          </p>
          <p className="font-mono text-[10px] sm:text-[11px] uppercase tracking-[0.2em] text-slate-400 mt-3">
            {m.label}
          </p>
        </motion.div>
      ))}
    </div>

    <div
      data-testid="services-marquee"
      className="relative border-t border-line overflow-hidden py-5"
      aria-label="Services we cover"
    >
      <div className="marquee-track flex w-max items-center gap-8 pr-8">
        {[0, 1].map((copy) => (
          <div
            key={copy}
            aria-hidden={copy === 1}
            className="flex items-center gap-8"
          >
            {MARQUEE_ITEMS.map((item) => (
              <span
                key={`${copy}-${item}`}
                className="flex items-center gap-8 font-display font-semibold uppercase tracking-wide text-lg sm:text-xl text-slate-400 whitespace-nowrap"
              >
                {item}
                <Zap size={13} className="text-orange-600 fill-orange-600" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  </section>
);
};
